export default __webpack_public_path__ + "static/companySwirl-9ec21046ac12c637d2e373aa6fc82156.svg";